import React, { useState } from 'react';
import ModalTitle from '../modalTitle/ModalTitle';
import { CloseIcon, SubTitle, Text } from '../../../styles/common.styles';
import ModalFooter from '../modalFooter/ModalFooter';
import ColorPicker from '../colorPicker/ColorPicker';
import { ChangeColorModalStyled, ChangeColorSpin, ModalContent } from './ChangeColorModal.styles';
import { blueDark01 } from '../../../styles/colors';
import { useDefaultColor } from '../../../hooks/useDefaultColor';
import { Color } from '../../../redux/actions/colorsActions/types';

interface Props {
    isOpen: boolean;
    closeModal: () => void;
    onSubmit: (color: Color) => void;
    tagNames: string[];
    pending?: boolean;
}

const ChangeColorModal: React.FC<Props> = ({
    isOpen,
    closeModal,
    onSubmit,
    tagNames,
    pending,
}) => {

    const [popoverVisible, setPopoverVisible] = useState(false);
    const [color, setColor] = useDefaultColor(isOpen);

    const handleCancel = () => {
        setColor(null);
        closeModal();
    };

    const handleSubmit = () => {
        if (color) {
            onSubmit(color);
            setColor(null);
            closeModal();
        }
    };

    return (
        <ChangeColorModalStyled
            open={isOpen}
            onCancel={handleCancel}
            centered
            footer={null}
            closeIcon={<CloseIcon />}
        >
            <ChangeColorSpin spinning={pending ?? false}>
                <ModalContent>
                    <ModalTitle style={{ marginBottom: '24px' }} title="Change color" icon="tag.svg" />
                    <SubTitle>
                        Select color for these tags
                    </SubTitle>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, marginLeft: '-8px' }}>
                        <ColorPicker
                            color={color}
                            setColor={setColor}
                            popoverVisible={popoverVisible}
                            setPopoverVisible={setPopoverVisible}
                        />
                    </span>
                    <Text size={15} weight={400} color={blueDark01} style={{ marginTop: '11px' }}>
                        {tagNames.join(', ')}
                    </Text>
                    <ModalFooter
                        cancel={handleCancel}
                        submit={handleSubmit}
                        action="Save"
                        cancelText="Cancel"
                    />
                </ModalContent>
            </ChangeColorSpin>
        </ChangeColorModalStyled>
    );
};

export default ChangeColorModal;
